import { Route } from "react-router-dom";
import Dashboard from "../pages/admin/Dashboard";
import Partner from "../pages/partner/Partner";
import Language from "../pages/languge/Language";
import TimeSlot from "../pages/timeslot/TimeSlot";
import States from "../pages/location/States";
import District from "../pages/location/District";
import Genre from "../pages/genre/Genre";
import News from "../pages/news/News";
import AddNews from "../pages/news/AddNews";
import Customer from "../pages/customer/Customer";
import Events from "../pages/events/Event";
import Gallery from "../pages/gallery/Gallery";
import Movies from "../pages/movies/Movies";
import AddMovie from "../pages/movies/AddMovie";
import Archived from "../pages/movies/Archived";
import SeatType from "../pages/seat_type/SeatType";
import Theatre from "../pages/theatre/Theatre";
import AddNewTheatre from "../pages/theatre/AddNew";
import ScreenTool from "../pages/theatre/ScreenTool";
import Shows from "../pages/show/Shows";
import ShowManagement from "../pages/show/ShowManagement";
import OldShows from '../pages/show/OldShows';
import ShowUpdate from "../pages/show/ShowUpdate";
import ShowRemarks from "../pages/show/ShowRemarks";
import Subscribers from "../pages/customer/Subscribers";
import JunkData from "../pages/booking/JunkData";
import Bookings from "../pages/booking/Bookings";
import ExternalTheatre from "../pages/external_theatre/ExternalTheatre";
import Reservation from "../pages/show/Reservation";
import ReservationDetail from "../pages/show/ReservationDetail";
import TicketSnapshots from "../pages/booking/TicketSnapshots";
import EventBookings from "../pages/booking/EventBookings";
import EventTicketSnapshots from "../pages/booking/EventTicketSnapshots";
import RoleRedirect from "../layouts/RoleRedirect";
import AdminDashboardLayout from "../layouts/AdminDashboardLayout";
import TheaterDashboardLayout from "../theater_layout/TheaterDashboardLayout";
import AddStaff from "../pages/theatre/AddStaff";
import StaffProfile from "../pages/theater_staff/StaffProfile";
import ShowList from "../pages/theater_staff/ShowList";
import CompletedShows from "../pages/theater_staff/CompletedShows";
import ShowDetail from "../pages/theater_staff/ShowDetail";
import TicketSnapshotsDetail from "../pages/theater_staff/TicketSnapshotsDetail";
import FlashNews from "../pages/news/FlashNews";
import MissedTicketGeneration from "../pages/booking/MissedTicketGeneration";
import RowPriceUpdate from "../pages/show/RowPriceUpdate";
import ShowBookingSummary from "../pages/show/ShowBookingSummary";
import AddEventStaff from "../pages/events/AddEventStaff";
import EventDashboardLayout from "../event_layout/EventDashboardLayout";
import EventProfile from "../pages/event_staff/EventProfile";
import EventShowList from "../pages/event_staff/EventShowList";
import EventCompletedShows from "../pages/event_staff/EventCompletedShows";
import EventShowDetail from "../pages/event_staff/EventShowDetail";
import EventTicketSnapshotsDetail from "../pages/event_staff/EventTicketSnapshotsDetail";
import EventSections from "../pages/events/EventSections";
import SectionModal from "../pages/events/SectionModal";

const dashboardRoutes = (
  <>
    {/* This catches the redirect after login and sends user to correct dashboard */}
    <Route path="/dashboard" element={<RoleRedirect />} />

    {/* ADMIN PROTECTED ROUTES */}
    <Route path="/admin/*" element={<AdminDashboardLayout />}>
      <Route index element={<Dashboard />} />
      <Route path="partners" element={<Partner />} />

      <Route path="masters/languages" element={<Language />} />
      <Route path="masters/time-slots" element={<TimeSlot />} />
      <Route path="masters/states" element={<States />} />
      <Route path="masters/districts" element={<District />} />
      <Route path="masters/genre" element={<Genre />} />
      <Route path="masters/seat-type" element={<SeatType />} />
      <Route path="masters/external-theatre" element={<ExternalTheatre />} />

      <Route path="news" element={<News />} />
      <Route path="add-news" element={<AddNews />} />
      <Route path="update-news/:id" element={<AddNews />} />
      <Route path="flash-news" element={<FlashNews />} />

<Route path="events" element={<Events />} />
      <Route path="event-sections" element={<EventSections />} />
      <Route path="event-section-edit/:id" element={<SectionModal />} />

      <Route path="gallery" element={<Gallery />} />

      <Route path="movie/upcoming" element={<Movies />} />
      <Route path="movie/add-new" element={<AddMovie />} />
      <Route path="movie/update-movie/:id" element={<AddMovie />} />
      <Route path="movie/archived" element={<Archived />} />

      <Route path="theatre" element={<Theatre />} />
      <Route path="theatre/add-new" element={<AddNewTheatre />} />
      <Route path="theatre/:id" element={<AddNewTheatre />} />
      <Route path="theatre/screen/:theatreId/:screenId" element={<ScreenTool />} />
      <Route path="theatre/add-staff" element={<AddStaff />} />
      <Route path="events/add-staff" element={<AddEventStaff />} />

      <Route path="shows" element={<Shows />} />
      <Route path="shows/manage" element={<ShowManagement />} />
      <Route path="shows/edit/:id/:movieId" element={<ShowUpdate />} />
      <Route path="shows/remarks/:showId/:date/:timeslotId" element={<ShowRemarks />} />
      <Route path="shows/old" element={<OldShows />} />
      <Route path="shows/confirm-reservation" element={<Reservation />} />
      <Route path="shows/reserve/:id/:movieId" element={<ReservationDetail />} />
      <Route path="shows/row-prices/:showId/:dateId/:timeslotId" element={<RowPriceUpdate />} />
      <Route path="shows/booking-summary/:showId" element={<ShowBookingSummary />} />

      <Route path="customers" element={<Customer />} />
      <Route path="subscribers" element={<Subscribers />} />

      <Route path="unpaid-bookings" element={<JunkData />} />
      <Route path="paid-bookings" element={<Bookings />} />
      <Route path="ticket-snapshots" element={<TicketSnapshots />} />
      <Route path="event-bookings" element={<EventBookings />} />
      <Route path="event-ticket-snapshots" element={<EventTicketSnapshots />} />
      <Route path="missed-tickets" element={<MissedTicketGeneration />} />
    </Route>

    {/* EVENT STAFF PROTECTED ROUTES */}
    <Route path="/event/*" element={<EventDashboardLayout />}>
      {/* Default page when event staff logs in */}
      <Route index element={<EventProfile />} />
      <Route path="profile" element={<EventProfile />} />
      <Route path="shows" element={<EventShowList />} />
      <Route path="completed-shows" element={<EventCompletedShows />} />
      <Route path="shows/:showId" element={<EventShowDetail />} />
      <Route path="snapshots/:showId" element={<EventTicketSnapshotsDetail />} />
    </Route>

    {/* THEATER STAFF PROTECTED ROUTES */}
    <Route path="/theater/*" element={<TheaterDashboardLayout />}>
      {/* Default page when theater staff logs in */}
      <Route index element={<StaffProfile />} />           {/* /theater → Profile */}

      {/* Optional: same page accessible via /theater/profile */}
      <Route path="profile" element={<StaffProfile />} />
      <Route path="shows" element={<ShowList />} />
      <Route path="completed-shows" element={<CompletedShows />} />
      <Route path="shows/:showId/:dateId/:timeslotId" element={<ShowDetail />} />
      <Route path="snapshots/:showId/:dateId/:timeslotId" element={<TicketSnapshotsDetail />} />
      {/* Add more theater staff pages here later */}
    </Route>
  </>


);


export default dashboardRoutes;
